export const naomiTimeline = [
  {
    age: "Goldilocks",
    descriptor: "Laura Lam",
    quote: "30/04/20",
    events: [
      "Ravaged by environmental disaster, greed and oppression, our planet is in crisis. The future of humanity hangs in the balance - and one woman can tip it over.",
      "Despite increasing restrictions on the freedoms of women on Earth, Valerie Black is spearheading the first all-female mission to a planet in the Goldilocks Zone, where conditions are just right for human habitation.",
      "It's humanity's last hope for survival, and Naomi, Valerie's surrogate daughter and the ship's botanist, has been waiting her whole life for an opportunity like this - to step out of Valerie's shadow and really make a difference.",
      "But when things start going wrong on the ship, Naomi starts to suspect that someone on board is concealing a terrible secret - and realises time for life on Earth may be running out faster than they feared...",
      "This is The Martian by way of The Handmaid's Tale - a bold and thought-provoking new high-concept thriller.",
    ],
  },
  {
    age: "9yrs",
    descriptor: "Childhood",
    quote: "She wakes up to flames. Calls out for her mother and breathes in smoke.",
    events: [
      "Naomi Lovelace, orphaned by a wildfire that tore through California, is taken in by Valerie Black",
      "Private firefighters and policemen are hired by the 1%.",
      "After the success of the Lunar Gateway, astronauts return to the moon, establishing a base.",
    ],
  },
  {
    age: "16yrs",
    descriptor: "World Events",
    quote: "Cavendish. Our new world. Our frontier.",
    events: [
      "The exosolar planet Cavendish discovered orbiting Epsilon Eridani.",
      "Hawthorne, Valerie Black's company, shuts down Haven, one of her sub-companies, after organ cloning is deemed illegal.",
    ],
  },
  {
    age: "18yrs",
    descriptor: "Studies",
    quote: "So we turned our attention to Mars, inhabiting it with the descendants of Curiosity, Rover, Perseverance, Spirit.",
    events: [
      "Naomi is a freshman at Stanford",
      "'Additional' Child Tax implemented; women are urged to take five years off employment to look after children.",
      "The moon base is abandoned in favor of diverting resources to the Ares mission.",
    ],
  },
  {
    age: "22yrs",
    descriptor: "Ares Mission",
    quote: "I got the sense what he really wanted was to go back to Earth to be a man who had gone to Mars.",
    events: [
      "Ares mission to Mars takes place, with members such as Cole Palmer and Jerrie Hixon.",
    ],
  },
  {
    age: "24yrs",
    descriptor: "8 Years Before Launch",
    quote: "...project will take decades, maybe even up to a century, and, frankly, we don’t have that long.",
    events: [
      "Mars is populated by robots that are beginning the long road to terraforming the red planet for human habitation.",
      "Sea barriers are erected to lessen the effects of climate change storms.",
      "President Cochran is elected.",
    ]
  },
  {
    age: "25yrs",
    descriptor: "7 Years Before Launch",
    quote: "Cavendish would likely look like a world on the edge of perpetual sunset.",
    events: [
      "UN Climate Change Conference takes place.",
      "Valerie Black displays a mini Cavendish biome that Naomi created, to foster support for journeying to the exosolar planet.",
    ],
  },
  {
    age: "26yrs",
    descriptor: "6 Years Before Launch",
    quote: " A bare face in the Golden State was the equivalent of smoking two packs of cigarettes a day without even the nicotine buzz.",
    events: [
      "Filter masks are required outdoors by law for public health.",
      "Naomi Lovelace gets into NASA.",
    ],
  },
  {
    age: "27yrs",
    descriptor: "5 Years Before Launch",
    quote: "only a few governments were able to push through legislation to replace fossil fuels quickly enough.",
    events: [
      "Earth has lessened fossil fuel usage by 90 percent, but Co2 levels continue to rise.",
      "Climate change activists are routinely arrested.",
    ],
  },
  {
    age: "28yrs",
    descriptor: "4 Years Before Launch",
    quote: "Naomi still had a chance at going to space on this side of the pond.",
    events: [
      "Naomi leaves NASA when she realises they will never send her to space.",
      "Naomi joins Lockwood and moves from Houston to the Sutherland Spaceport in Scotland.",
      "Worldwide bee and insect population lowers to dangerous levels.",
    ],
  },
  {
    age: "29yrs",
    descriptor: "3 Years Before Launch",
    quote: "I need you, Naomi. No one else will do.",
    events: [
      "Valerie Black invites Naomi Lovelace to join her on the Cavendish mission.",
      "Hawthorne throws a lavish charity dinner to raise funds for the building of the Atalanta spaceship.",
    ],
  },
  {
    age: "32yrs",
    descriptor: "Launch",
    quote: "Naomi would say no one who has been to space could ever describe it to someone who hasn’t.",
    events: [
      "Launch of Atalanta and the first all female interstellar mission to Cavendish.",
      "Projected to arrive in Mars Orbit 126 Days Later.",
      "Test Mars Warp ring.",
      "Jump to atomic clock projection location near Epsilon Eridani.",
      "Projected to arrive in Cavendish orbit 118 days later.",
    ],
  },
  {
    age: "63yrs",
    descriptor: "After",
    quote: "The night sky is so clear – spilled ink speckled with stars.",
    events: [
      "Naomi Lovelace finally agrees to an official interview to tell the world what really happened on the Atalanta.",
    ],
  },
];
